import { configureStore } from '@reduxjs/toolkit'
import { reducer as userInfoReducer } from './user-info'
import { reducer as guildInfoReducer } from './guild-info'
import { reducer as countryList } from './country'

export const store = configureStore({
  reducer: {
    userInfo: userInfoReducer,
    guildInfo: guildInfoReducer,
    countryList: countryList,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch